import React from "react";
import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
const faqs = [{
  question: "What is included in the serviced accommodation?",
  answer: "Our properties are fully furnished and equipped with modern amenities to provide the comfort of home. This includes high-speed Wi-Fi, fully equipped kitchens, fresh linens, towels, and regular housekeeping for longer stays."
}, {
  question: "How do flexible booking options work?",
  answer: "We cater to both short-term leisure guests and long-term business travelers or contractors. You can book for a few nights, weeks, or even months, with pricing structures that adapt to the length of your stay."
}, {
  question: "What is the check-in and check-out process?",
  answer: "We offer a seamless, contactless check-in process. Prior to your arrival, you will receive detailed instructions and a secure access code to enter the property at your convenience after the designated check-in time."
}, {
  question: "Is guest support available during my stay?",
  answer: "Yes, exceptional guest support is one of our core commitments. Our dedicated team is available to assist you with any inquiries, maintenance requests, or local recommendations throughout your entire stay."
}, {
  question: "Are the properties located in central areas?",
  answer: "Absolutely. Praise Space carefully selects prime locations that offer convenient access to business districts, transport links, and local attractions, ensuring you are always well-connected."
}];
export default function CommonQuestions() {
  return <section id="common-questions" className="bg-primary text-primary-foreground py-24 md:py-44 relative">
      {}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden border-t border-chart-3/30 py-2 bg-primary z-10">
        <div className="whitespace-nowrap animate-[ticker_40s_linear_infinite] flex gap-4 font-mono text-[10px] tracking-[0.15em] text-chart-3 uppercase">
          {Array.from({
          length: 10
        }).map((_, i) => <span key={i} data-index={i}>Comfort • Reliability • Cleanliness •</span>)}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8">
          
          {}
          <div className="lg:col-span-8 relative">
            {}
            <div className="absolute -top-24 md:-top-44 left-2 w-px h-24 md:h-44 bg-chart-3" aria-hidden="true" />
            <div className="absolute top-0 left-[6px] w-1 h-1 rounded-lg bg-chart-3" aria-hidden="true" />

            <div className="pl-8 md:pl-12 mb-16">
              <h2 className="font-default text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight">
                <span className="block ml-8 text-chart-3">Common</span>
                Questions
              </h2>
            </div>

            <div className="pl-8 md:pl-12">
              <Accordion type="single" collapsible className="w-full">
                {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-chart-3 py-2">
                    <AccordionTrigger className="font-default text-xl md:text-2xl font-medium text-left hover:no-underline hover:text-secondary transition-colors group">
                      {faq.question}
                    </AccordionTrigger>
                    <AccordionContent className="font-sans text-base md:text-lg text-primary-foreground/70 leading-relaxed pt-2 pb-6 max-w-3xl">
                      {faq.answer}
                    </AccordionContent>
                  </AccordionItem>)}
              </Accordion>
            </div>
          </div>

          {}
          <div className="lg:col-span-4 relative">
            <div className="sticky top-32 flex flex-col gap-8 pl-8 md:pl-0 border-l border-chart-3/30 md:border-none ml-8 md:ml-0">
              <div>
                <span className="font-mono text-xs font-semibold tracking-[0.15em] uppercase text-chart-3 block mb-4">
                  Support
                </span>
                <h3 className="font-default text-2xl md:text-3xl font-medium mb-4">
                  Still have questions?
                </h3>
                <p className="font-sans text-primary-foreground/70 leading-relaxed mb-8">
                  Our guest support team is available to help you with any specific inquiries about your stay, booking options, or property amenities.
                </p>
                
                <div className="flex flex-col sm:flex-row lg:flex-col gap-4">
                  <Button variant="secondary" size="lg" asChild className="w-full sm:w-auto lg:w-full rounded-sm">
                    <Link to="/ContactPage">Contact Support</Link>
                  </Button>
                  
                  <div className="flex items-center gap-3 px-4 py-3 border border-chart-3/50 rounded-sm text-primary-foreground/80">
                    <Phone className="w-4 h-4 text-chart-3" />
                    <span className="font-mono text-sm">07956675231</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `
    }} />
    </section>;
}